/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator

      window.localStorage.setItem("hasSubscription", false);
      cart.items.forEach((item) => {
        if (
          (item?.selling_plan_allocation?.selling_plan?.name || "").includes(
            "Delivery every"
          )
        ) {
          window.localStorage.setItem("hasSubscription", true);
        }
      });
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  window.onload = function () {
    const loginLogoutButtons = document.querySelectorAll(
      "#drawer-account [href*='logout'], #CustomerLoginFormDrawer button, #customer_login button"
    );

    loginLogoutButtons.length > 0 &&
      loginLogoutButtons.forEach((button) => {
        button.addEventListener("click", function () {
          localStorage.setItem("modalShown", "false");
        });
      });

    function openModal(modal) {
      const showFormButton = modal.querySelector("[data-show-form-button]");
      const modalContent = modal.querySelector(".ssn-reminder");
      const modalSsnForm = modal.querySelector(".ssn-reminder-form");
      const modalClose = modal.querySelectorAll("[data-micromodal-close]");
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      showFormButton.addEventListener("click", function () {
        modalContent.classList.add("hide");
        modalSsnForm.classList.remove("hide");
      });

      modalClose.forEach((closeElement) =>
        closeElement.addEventListener("click", function () {
          modal.classList.remove("is-open");
          modal.setAttribute("aria-hidden", "true");
          document.body.style.overflow = "";
        })
      );
    }

    if (localStorage.getItem("modalShown") !== "true") {
      const modal = document.getElementById("ssn-reminder");
      if (!modal) return;
      openModal(modal);
      localStorage.setItem("modalShown", "true");
    }
  };

  const loginForm = document.querySelector("form[action='/account/login']");
  const onboardingWizard = document.getElementById("onboarding_wizard");
  const onboardingOverlay = document.getElementById("wizard_modal_overlay");
  const formSubmitted = localStorage.getItem("FormSubmitted");
  const onboardingModalShown = localStorage.getItem("OnboardingModalShown");

  if (loginForm) {
    loginForm.addEventListener("submit", () => {
      localStorage.setItem("OnboardingModalShown", false);
    })
  }
  
  if (onboardingWizard && onboardingOverlay) {
    if (formSubmitted !== "true" && onboardingModalShown !== "true") {
      onboardingWizard.classList.remove("hide");
      onboardingOverlay.classList.remove("hide");
    } else {
      onboardingWizard.classList.add("hide");
      onboardingOverlay.classList.add("hide");
    } 
  }
  document.addEventListener("DOMContentLoaded", function () {
    const openModalLink = document.getElementById("openModalLink");
   
    // Open modal
    openModalLink.addEventListener("click", function(event) {
      event.preventDefault();
      onboardingWizard.classList.remove("hide");
      onboardingOverlay.classList.remove("hide");
    });
  });
})();
